import styled from '@emotion/styled';

const ModalStyle = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default ModalStyle;
